exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.video-seek[data-v-7c7e6b07] {\n\t-webkit-appearance: none;\n\tappearance: none;\n\theight: 0.25rem;\n\tborder-radius: 9999px;\n\tbackground: rgba(255, 255, 255, 0.3);\n\tcursor: pointer;\n}\n.video-seek[data-v-7c7e6b07]::-webkit-progress-bar {\n\tbackground: rgba(255, 255, 255, 0.3);\n\tborder-radius: 9999px;\n}\n.video-seek[data-v-7c7e6b07]::-webkit-progress-value {\n\tbackground: #ffffff;\n\tborder-radius: 9999px;\n}\n.video-seek[data-v-7c7e6b07]::-moz-progress-bar {\n\tbackground: #ffffff;\n\tborder-radius: 9999px;\n}\n", ""]);

// exports
